const welcome = {
    title: 'Willkommen in der Admin Konsole',
    description: 'Die Admin-Konsole ist eine Web-App, mit der du JX Account verwalten kannst, ohne programmieren zu müssen. Legen wir zunächst ein Konto an. Mit diesem Konto kannst du JX Account selbst oder im Namen deines Unternehmens verwalten.',
    create_account: 'Konto erstellen',
};
export default Object.freeze(welcome);
